import { IAttentionDay } from "../../domain/attentiondays/IAttentionDay";
import { IAttentionDayRepository } from "../../domain/attentiondays/IAttentionDayRepository";
import { restApiHelper } from "../helpers/RestApiHelper";
import { mapAttentionday } from "./Mappers/mapAttentionday";

export class AttentionDayRepository implements IAttentionDayRepository {

    async getById(id: string): Promise<IAttentionDay> {
        const data = await restApiHelper.getData(`api/attentionDay/${id}`);
        return mapAttentionday(data);
    }

    async getAttentionDays(): Promise<IAttentionDay[]> {
        const data = await restApiHelper.getData("api/attentionDay", {});
        return data.map(mapAttentionday);
    }
    async createAttentionDay(attentionDay: IAttentionDay): Promise<IAttentionDay> {
        const data = await restApiHelper.post("api/attentionDay", attentionDay);
        return mapAttentionday(data);
    }
    async updateAttentionDay(attentionDay: IAttentionDay): Promise<IAttentionDay> {
        const data = await restApiHelper.put("api/attentionDay", attentionDay);
        return mapAttentionday(data);
    }
    async deleteAttentionDay(attentionDay: IAttentionDay): Promise<IAttentionDay> {
        const data = await restApiHelper.delete("api/attentionDay", attentionDay);
        return mapAttentionday(data);
    }

    async importAttentionDays(): Promise<any> {
        return await restApiHelper.post("api/attentionDay/importandcalculate");
    }
}
